import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import PageHeadingNew from "../../components/common-components/custom-comps/PageHeadingNew";
import CallLogsTable from "../../components/campaign/lead-calls/CallLogsTable";
import { fetchCallLogsData } from "../../redux/prospect-reducers/prospectSlice";

const CallLogs = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  // const { callLogsLoading, callLogsError, callLogsData } = useSelector(
  //   (state) => state.prospects
  // );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  //   const iniAllFilter = {};
  //   const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);

  function getLeadCallLogs(filters) {
    dispatch(
      fetchCallLogsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getLeadCallLogs(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  return (
    <HelmetWrapper title="WTF: Lead Call Logs">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <PageHeadingNew
              heading="Lead Call Logs"
              subheading="View and track all lead call recordings and statuses"
              onReload={() => getLeadCallLogs(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CallLogsTable
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CallLogs;
